import { useEffect, useState } from 'react';
import i18next from 'i18next';
import MagexLogo from '../../Icons/Magex_logo.png';
import { useHistory } from 'react-router';
import localRequest from '../../services/LocalServer/localRequest';
import request from '../../services/Request';
import logger from '../../services/LocalServer/logger';
import { useTranslation } from 'react-i18next';
import { rearrangeBasedOnFirstArray } from '../../services/methods';
import isvpayWebSocketService from '../../services/isvpayWebSocketService';
import paymentService from '../../services/paymentService';

const getMachineURL = `${process.env.REACT_APP_LOCAL_API}/getMachine`;
const getPromoURL = `${process.env.REACT_APP_LOCAL_API}/getPromo`;
const getAllProdURL = `${process.env.REACT_APP_LOCAL_API}/getProduct`;
const getAllCateURL = `${process.env.REACT_APP_LOCAL_API}/getCategory`;
const getAllBrandURL = `${process.env.REACT_APP_LOCAL_API}/getBrand`;
const getReinstate = `${process.env.REACT_APP_LOCAL_API}/getReinstateStatus`;

const getMachineURLR = `${process.env.REACT_APP_SERVER_API}/machines/withUPC/`;
const getPromoURLR = `${process.env.REACT_APP_SERVER_API}/promos/machine/`;
const getAllProdURLR = `${process.env.REACT_APP_SERVER_API}/machines/getMachineUIproduct/`;
const getAllCateURLR = `${process.env.REACT_APP_SERVER_API}/machines/getFilteredCategroy/`;
const getAllBrandURLR = `${process.env.REACT_APP_SERVER_API}/machines/getFilteredBrand/`;
const getAudioByMachineID = `${process.env.REACT_APP_SERVER_API}/getAudioByMachineID/`;

function checkBundleStock(item, copy) {
  if (item.prodType === 'bundle' && item?.bundle_prod?.length > 0) {
    //format bundle with quanlity
    let newBundle = [];

    item.bundle_prod.forEach((bd) => {
      const findIndex = newBundle.findIndex((e) => e._id == bd);
      if (findIndex > -1) {
        newBundle[findIndex].quantity += 1;
      } else {
        newBundle.push({
          _id: bd,
          quantity: 1,
        });
      }
    });

    item.bundle_prod = newBundle;

    //check does machine has enough stock
    let stock = true;
    newBundle.forEach((item) => {
      let idx = copy.findIndex((e) => e._id === item._id);
      if (idx > -1) {
        item.price = copy[idx].price;
        item.name = copy[idx].name;
        if (copy[idx].current_stock < item.quantity) {
          stock = false;
          return;
        }
      } else {
        stock = false;
      }
    });

    //percentage of new price
    // console.log('item', item);
    // console.log('totalOldPrice', totalOldPrice);
    // const newPercentage = item.price / totalOldPrice;
    // console.log('newPercentage', newPercentage);

    if (!stock) {
      item.current_stock = 0;
    } else {
      item.current_stock = 1;
      item.max_stock = 1;
    }
  }
  return item;
}

function Initial(props) {
  const { t } = useTranslation();
  const { stat, setStat, setThemeColor, audio, setAudio, stopPlay, setClientUser } = props;
  const [info, setInfo] = useState(null);
  const [initText, setInitText] = useState('');
  const history = useHistory();
  const machineID = props.id;
  localStorage.setItem('uiCompanyId', 'companyA');
  let outofStock = false;
  let items = [];
  let filteredProducts = [];
  let categoryArray = [];
  let language = 'en';
  const isLocal = localStorage.getItem('ISLOCAL') === 'TRUE';
  const isHelloFresh = localStorage.getItem('HELLO_FRESH') === 'TRUE';

  useEffect(async () => {
    setClientUser(null);
    const runAudio = async () => {
      let myAudio = null;
      if (isLocal) {
        await localRequest({
          method: 'get',
          url: `${process.env.REACT_APP_LOCAL_API}/getAudio`,
        })
          .then(async (res) => {
            if (res.data.length > 0) {
              myAudio = res.data[0];
            }
          })
          .catch((err) => {
            console.log(err);
            logger(0, 'Errors when downloading audio' + JSON.stringify(err));
          });
      } else {
        await request({
          method: 'get',
          url: getAudioByMachineID + machineID,
        })
          .then(async (res) => {
            myAudio = res.data;
          })
          .catch((err) => {
            logger(0, 'Errors when downloading audio' + JSON.stringify(err));
          });
      }
      console.log('myaudio', myAudio);

      if (myAudio?.start !== '') {
        audio.start = new Audio(
          isLocal
            ? `${process.env.REACT_APP_LOCAL_API}/pictures/audio/${myAudio.start}`
            : `${process.env.REACT_APP_SERVER_API}/videos/${myAudio.start}/${myAudio.referTo}`
        );
      }
      if (myAudio?.cart !== '') {
        audio.cart = new Audio(
          isLocal
            ? `${process.env.REACT_APP_LOCAL_API}/pictures/audio/${myAudio.cart}`
            : `${process.env.REACT_APP_SERVER_API}/videos/${myAudio.cart}/${myAudio.referTo}`
        );
      }
      if (myAudio?.dispense !== '') {
        audio.dispense = new Audio(
          isLocal
            ? `${process.env.REACT_APP_LOCAL_API}/pictures/audio/${myAudio.dispense}`
            : `${process.env.REACT_APP_SERVER_API}/videos/${myAudio.dispense}/${myAudio.referTo}`
        );
      }
      if (myAudio?.checkout !== '') {
        audio.checkout = new Audio(
          isLocal
            ? `${process.env.REACT_APP_LOCAL_API}/pictures/audio/${myAudio.checkout}`
            : `${process.env.REACT_APP_SERVER_API}/videos/${myAudio.checkout}/${myAudio.referTo}`
        );
      }
      if (myAudio?.doorOpen !== '') {
        audio.doorOpen = new Audio(
          isLocal
            ? `${process.env.REACT_APP_LOCAL_API}/pictures/audio/${myAudio.doorOpen}`
            : `${process.env.REACT_APP_SERVER_API}/videos/${myAudio.doorOpen}/${myAudio.referTo}`
        );
      }
      if (myAudio?.doorClose !== '') {
        audio.doorClose = new Audio(
          isLocal
            ? `${process.env.REACT_APP_LOCAL_API}/pictures/audio/${myAudio.doorClose}`
            : `${process.env.REACT_APP_SERVER_API}/videos/${myAudio.doorClose}/${myAudio.referTo}`
        );
      }
      setAudio(audio);
    };

    runAudio();

    if (props.test !== 'true') {
      const instateStatus = new Promise((resolve, reject) => {
        localRequest({
          method: 'get',
          url: getReinstate,
        }).then((res) => {
          console.log('reinstate', res.data);
          if (res.data) resolve(1);
          else resolve(0);
        });
      });
      const isGo = await instateStatus;
      const delay = (ms) => new Promise((res) => setTimeout(res, ms));

      if (isGo) {
        await delay(localStorage.getItem('INI_TIME') ? localStorage.getItem('INI_TIME') : 10000);
      }
    }
    await props.setShowCart(false);
    props.cleanUp();
    let myMachineObj = null;
    localStorage.removeItem('MagexApp.cart');
    localStorage.removeItem('promo');
    localStorage.removeItem('codePromo');
    localStorage.removeItem('oneTime');
    localStorage.removeItem('machine');
    localStorage.removeItem('products');
    localStorage.removeItem('category');
    localStorage.removeItem('brand');
    let machine = null;

    const voidMachine = (res, setDefaultLogo) => {
      console.log('machine', res);
      logger(2, 'Void Machine Start');
      // logger(2, 'machines' + JSON.stringify(res));
      let promise = new Promise((resolve, reject) => {
        try {
          const style = document.createElement('style');
          document.head.appendChild(style);
          setThemeColor(res.data.themeColor);
          if (res.data.themeColor) {
            if (res.data.themeColor.text) {
              document.body.style.setProperty('--text-color', res.data.themeColor.text);
            }
            if (res.data.themeColor.highlight_color) {
              document.body.style.setProperty(
                '--highlight-color',
                res.data.themeColor.highlight_color
              );
            }
            if (res.data.themeColor.cart_color) {
              document.body.style.setProperty('--cart-color', res.data.themeColor.cart_color);
            }
            if (res.data.themeColor.theme) {
              document.body.style.setProperty('--theme-color', res.data.themeColor.theme);
            }
            if (res.data.themeColor.price) {
              document.body.style.setProperty('--price-color', res.data.themeColor.price);
            }
            if (res.data.themeColor.plus) {
              document.body.style.setProperty('--plus-color', res.data.themeColor.plus);
            }
            if (res.data.themeColor.minus) {
              document.body.style.setProperty('--minus-color', res.data.themeColor.minus);
            }
            if (res.data.themeColor.soldout) {
              document.body.style.setProperty('--soldout-color', res.data.themeColor.soldout);
            }
            if (res.data.themeColor.soldout_text) {
              document.body.style.setProperty('--soldout-text', res.data.themeColor.soldout_text);
            }
            if (res.data.themeColor.navibar) {
              document.body.style.setProperty('--navi-color', res.data.themeColor.navibar);
            }
            if (res.data.themeColor.button) {
              document.body.style.setProperty('--buttons-color', res.data.themeColor.button);
            }
            if (res.data.themeColor.product_text) {
              document.body.style.setProperty('--product-text', res.data.themeColor.product_text);
            }
            if (res.data.themeColor.background)
              document.body.style.setProperty('--background-color', res.data.themeColor.background);
            if (res.data.themeColor.secondary)
              document.body.style.setProperty('--container-color', res.data.themeColor.secondary);
            // if (res.data.themeColor.search_form)
            //   document.body.style.setProperty(
            //     '--search-form-color',
            //     res.data.themeColor.search_form
            //   );
            if (res.data.themeColor.backgroundImage) {
              const bgURL = isLocal
                ? `
          .main-container {
              background-color: white;
              background-attachment: fixed;
              background-image: url(${process.env.REACT_APP_LOCAL_API}/pictures/machines/${res.data.themeColor.backgroundImage});
          }
      `
                : `
      .main-container {
          background-color: white;
          background-attachment: fixed;
          background-image: url(${process.env.REACT_APP_SERVER_API}/pictures/${res.data.themeColor.backgroundImage}/${res.data.belongTo});
      }
      `;
              style.sheet.insertRule(bgURL);
            }
            if (res.data.themeColor.logo) {
              const logoURL = isLocal
                ? `
          .home-logo {
              content:url(${process.env.REACT_APP_LOCAL_API}/pictures/machines/${res.data.themeColor.logo});
          }
            `
                : `
            .home-logo {
                content: url(${process.env.REACT_APP_SERVER_API}/pictures/${res.data.themeColor.logo}/${res.data.belongTo})
            }
            `;
              // document.querySelector('.homeImg').style.content = `url(${MagexLogo})`;
              style.sheet.insertRule(logoURL);
            } else {
              style.sheet.insertRule(`
          .home-logo {
              content: url(${MagexLogo})
          }
          `);
            }
          }

          //set primary language
          i18next.changeLanguage(res.data.languages[0].code);
          props.setlangs(res.data.languages[0].code);
          language = res.data.languages[0].code;
          localStorage.setItem('machineID', machineID);
          localStorage.setItem('machine', JSON.stringify(res.data));
          myMachineObj = res.data;
          props.setMachine(res.data);
          machine = res.data;
          //init Text
          if (res.data.themeColor.initText) {
            setInitText(res.data.themeColor.initText);
          } else {
            setInitText(t(`Initializing...`));
          }

          resolve('done');
          logger(2, 'Void Machine Complete');
        } catch (e) {
          logger(0, 'Void Machine Error = ' + JSON.stringify(e));
          history.push(`/machineUI/slider/${machineID}`);
        }
      });

      promise.then();
    };

    const voidProd = async (res) => {
      logger(2, 'Void Product Start');
      let copy = [...res.data];
      let products = res.data;

      if (
        copy?.length == 0 &&
        process.env.REACT_APP_DEV === 'TRUE' &&
        process.env.REACT_APP_DEV_MACHINE_ID
      ) {
        await request({
          method: 'get',
          url: getAllProdURLR + process.env.REACT_APP_DEV_MACHINE_ID,
        }).then((res) => {
          copy = [...res.data];
          products = res.data;
        });
      }

      //filter hided products
      const hideProducts = myMachineObj.products_hide;
      hideProducts.forEach((hide) => {
        let hideIndex = products.findIndex((e) => hide == e._id);
        if (hideIndex > -1) {
          products.splice(hideIndex, 1);
        }
      });

      const bestMachineArray = myMachineObj.products_bs;
      let bestSeller = [];

      if (props.test === 'true' || process.env.REACT_APP_DEV === 'TRUE') {
        // if (false) {
        console.log('goes in DEV MODEDDD', copy);
        copy.forEach((item, i) => {
          item.idx = i;

          checkBundleStock(item, copy);

          if (process.env.REACT_APP_DISABLE_SCREENSAVER !== 'TRUE') {
            // current_stock will not be 0 when in preview mode but not dev mode
            if (item.prodType !== 'linkedBox') {
              item.current_stock = 4;
              item.max_stock = item.current_stock;
            }
          }

          if (!item.name.es) {
            item.name.es = '';
          }
          if (!item.name.fr) {
            item.name.fr = '';
          }
          if (!item.name.zh) {
            item.name.zh = '';
          }
        });

        if (bestMachineArray?.length > 0) {
          if (myMachineObj?.themeColor?.sp_column === '1') {
            copy = rearrangeBasedOnFirstArray(bestMachineArray, copy);
            console.log('goes in DEV MODEDDD after arrange', copy);
          }

          bestMachineArray?.forEach((bsProd) => {
            let index = copy.findIndex((e) => e._id == bsProd);
            if (index > -1) {
              bestSeller.push(copy[index]);
            }
          });
        } else {
          bestSeller = [...copy];
        }
        localStorage.setItem('bestSeller', JSON.stringify(bestSeller));
      } else {
        console.log('itemin', items);
        // console.log('allprod', products);
        const initializeNames = (item) => {
          item.name.es = item.name.es || '';
          item.name.fr = item.name.fr || '';
          item.name.zh = item.name.zh || '';
        };

        let i = 0;

        // Process regular items
        items.forEach((item) => {
          if (item.expiration_date) {
            const localString = item.expiration_date.replace('T', ' ');
            const date = new Date(localString);
            if (date < new Date()) return;
          }

          const index = products.findIndex((e) => e.upc == item.upc);
          if (index >= 0) {
            const product = products[index];
            product.current_stock = item.current_stock;
            product.max_stock = item.max_stock;
            product.idx = i++;
            initializeNames(product);
            filteredProducts.push(product);
          }
        });

        // Process bundle products
        const bundleProducts = products.filter((item) => item.prodType === 'bundle');
        bundleProducts.forEach((item) => {
          initializeNames(item);
          item.idx = i++;
          checkBundleStock(item, filteredProducts);
        });

        // Process other products (linked and fridge)
        const otherProducts = products.filter(
          (item) => item.prodType !== 'bundle' && item.prodType !== 'prod'
        );
        otherProducts.forEach((item) => {
          initializeNames(item);
          item.idx = i++;
        });

        filteredProducts = [...filteredProducts, ...bundleProducts, ...otherProducts];

        console.log('filteredProduct', filteredProducts);
        // console.log('bestMachineArray', bestMachineArray);
        bestMachineArray?.forEach((bsProd) => {
          let index = filteredProducts.findIndex((e) => e._id == bsProd);
          if (index > -1) {
            bestSeller.push(filteredProducts[index]);
          }
        });
        if (bestMachineArray?.length > 0 && myMachineObj?.themeColor?.sp_column === '1') {
          filteredProducts = rearrangeBasedOnFirstArray(bestMachineArray, filteredProducts);
        }
        localStorage.setItem('bestSeller', JSON.stringify(bestSeller));
        // console.log('bbsl', bestSeller);
      }

      try {
        const codePromo = JSON.parse(localStorage.getItem('promo'));
        // console.log(codePromo);
        //  console.log(codePromo)
        if (codePromo.length > 0) {
          codePromo.forEach((item) => {
            if (item.promoType === 'buyXProducts') {
              if (item.cateOrProd === 'cate') {
                if (item.category) {
                  for (let i = 0; i < item.category.length; i++) {
                    for (let j = 0; j < products.length; j++) {
                      //add !products[j].prodPromo for improve prod promotion priority
                      if (
                        !products[j].prodPromo &&
                        products[j].category.includes(item.category[i]._id)
                      ) {
                        products[j].promo = item._id;
                        products[j].promoType = item.promoType;
                        products[j].buyX = item.productsToBuy;
                        products[j].percentage = item.percentage;
                        products[j].discount = item.amount;
                        products[j].discountedPrice = item.percentage
                          ? products[j].price * (1 - item.amount)
                          : products[j].price - item.amount;
                        products[j].discountedPrice =
                          Math.round(products[j].discountedPrice * 100) / 100;
                        // products[j].discountedPrice = products[j].discountedPrice > 0 ? products[j].discountedPrice : 0.01;
                        if (products[j].discountedPrice < 0) {
                          products[j].discountedPrice = 0;
                          products[j].discount = products[j].price;
                        }
                      }
                    }
                  }
                }
              } else if (item.cateOrProd === 'prod') {
                if (item.product) {
                  for (let i = 0; i < item.product.length; i++) {
                    for (let j = 0; j < products.length; j++) {
                      if (item.product[i]._id == products[j]._id) {
                        products[j].discountedPrice = item.percentage
                          ? products[j].price * (1 - item.amount)
                          : products[j].price - item.amount;
                        products[j].discountedPrice =
                          Math.round(products[j].discountedPrice * 100) / 100;
                        products[j].buyX = item.productsToBuy;
                        products[j].promo = item._id;
                        products[j].promoType = item.promoType;
                        products[j].discount = item.amount;
                        products[j].percentage = item.percentage;
                        // products[j].discountedPrice = products[j].discountedPrice > 0 ? products[j].discountedPrice : 0;
                        // for checking prod promotion priority more
                        products[j].prodPromo = true;
                        if (products[j].discountedPrice < 0) {
                          products[j].discountedPrice = 0;
                          products[j].discount = products[j].price;
                        }
                      }
                    }
                  }
                }
              } else if (item.cateOrProd === 'All Products') {
                products.forEach((product) => {
                  product.promo = item._id;
                  product.promoType = item.promoType;
                  product.percentage = item.percentage;
                  product.discountedPrice = item.percentage
                    ? product.price * (1 - item.amount)
                    : product.price - item.amount;
                  product.discountedPrice = Math.round(product.discountedPrice * 100) / 100;
                  product.discount = item.amount;
                  product.buyX = item.productsToBuy;
                  product.percentage = item.percentage;
                  if (product.discountedPrice < 0) {
                    product.discountedPrice = 0;
                    product.discount = product.price;
                  }
                  // product.discountedPrice = product.discountedPrice > 0 ? product.discountedPrice : 0;
                });
              }
            } else if (item.promoType === 'general' || item.promoType === 'emailCode') {
              if (item.cateOrProd === 'cate') {
                if (item.category) {
                  for (let i = 0; i < item.category.length; i++) {
                    for (let j = 0; j < products.length; j++) {
                      //add !products[j].prodPromo for improve prod promotion priority
                      if (
                        !products[j].prodPromo &&
                        products[j].category.includes(item.category[i]._id)
                      ) {
                        if (item.promoType === 'emailCode') {
                          products[j].emailCode = true;
                        }
                        products[j].promo = item._id;
                        products[j].promoType = item.promoType;
                        products[j].discountedPrice = item.percentage
                          ? products[j].price * (1 - item.amount)
                          : products[j].price - item.amount;
                        products[j].discountedPrice =
                          Math.round(products[j].discountedPrice * 100) / 100;
                        products[j].buyX = 0;
                        products[j].discount = item.amount;
                        products[j].percentage = item.percentage;
                        if (products[j].discountedPrice < 0) {
                          products[j].discountedPrice = 0;
                          products[j].discount = products[j].price;
                        }
                        // products[j].discountedPrice = products[j].discountedPrice > 0 ? products[j].discountedPrice : 0.01;
                      }
                    }
                  }
                }
              } else if (item.cateOrProd === 'prod') {
                if (item.product) {
                  for (let i = 0; i < item.product.length; i++) {
                    for (let j = 0; j < products.length; j++) {
                      if (item.product[i]._id == products[j]._id) {
                        if (item.promoType === 'emailCode') {
                          products[j].emailCode = true;
                        }
                        products[j].promo = item._id;
                        products[j].promoType = item.promoType;
                        products[j].discountedPrice = item.percentage
                          ? products[j].price * (1 - item.amount)
                          : products[j].price - item.amount;
                        products[j].discountedPrice =
                          Math.round(products[j].discountedPrice * 100) / 100;
                        products[j].buyX = 0;
                        products[j].discount = item.amount;
                        products[j].percentage = item.percentage;
                        // products[j].discountedPrice = products[j].discountedPrice > 0 ? products[j].discountedPrice : 0;
                        // for checking prod promotion priority
                        products[j].prodPromo = true;
                        if (products[j].discountedPrice < 0) {
                          products[j].discountedPrice = 0;
                          products[j].discount = products[j].price;
                        }
                      }
                    }
                  }
                }
              } else if (item.cateOrProd === 'All Products') {
                products.forEach((product) => {
                  if (item.promoType === 'emailCode') {
                    product.emailCode = true;
                  }
                  product.promo = item._id;
                  product.promoType = item.promoType;
                  product.discountedPrice = item.percentage
                    ? product.price * (1 - item.amount)
                    : product.price - item.amount;
                  product.discountedPrice = Math.round(product.discountedPrice * 100) / 100;
                  product.buyX = 0;
                  product.discount = item.amount;
                  product.percentage = item.percentage;
                  if (product.discountedPrice < 0) {
                    product.discountedPrice = 0;
                    product.discount = product.price;
                  }
                  // product.discountedPrice = product.discountedPrice > 0 ? product.discountedPrice : 0;
                });
              }
            }
          });
        }
        // initial products state
        if (props.test === 'true' || process.env.REACT_APP_DEV === 'TRUE') {
          // if (false) {
          // console.log('bestSeller', bestSeller);
          // console.log('copy', copy);
          props.setProds(copy);
        } else {
          // console.log('bestSeller', bestSeller);
          // console.log('filteredProducts', filteredProducts);
          props.setProds(filteredProducts);
        }
        logger(2, 'Void Product Complete');
      } catch (e) {
        logger(0, 'Errors when apply promotion to products. ' + JSON.stringify(e));
      }
    };

    const getMachine = async () => {
      const setDefaultLogo = (style) => {
        document.querySelector('.homeImg').style.content = `url(${MagexLogo})`;
        style.sheet.insertRule(`
                .home-logo {
                    content: url(${MagexLogo})
                }
            `);
      };
      if (isLocal) {
        await localRequest({
          method: 'get',
          url: getMachineURL,
        })
          .then((res) => {
            // logger(2, 'localMachine' + JSON.stringify(res.data));
            console.log('localMachine', res.data);
            voidMachine(res, setDefaultLogo);
          })
          .catch((err) => {
            logger(0, 'Errors when downloading machine locally' + JSON.stringify(err));
            console.log(err);
          });
      } else {
        await request({
          method: 'get',
          url: getMachineURLR + machineID,
        })
          .then((res) => {
            // logger(2, 'remoteMachine' + JSON.stringify(res.data));
            voidMachine(res, setDefaultLogo);
          })
          .catch((err) => {
            logger(0, 'Errors when downloading machine remotely' + JSON.stringify(err));
            console.log(err);
          });
      }
    };

    const getPromo = async () => {
      if (isLocal) {
        await localRequest({
          method: 'get',
          url: getPromoURL,
        })
          .then((res) => {
            console.log('localPromo', res.data);
            localStorage.setItem('promo', JSON.stringify(res.data));
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        await request({
          method: 'get',
          url: getPromoURLR + machineID,
        })
          .then((res) => {
            localStorage.setItem('promo', JSON.stringify(res.data));
          })
          .catch((err) => {
            console.log(err);
          });
      }
    };

    const updateStatus = async () => {
      if (props.test == 'false') {
        await localRequest({
          method: 'get',
          url: '/outOfOrderRequest',
        }).then((res) => {
          if (res.data.status) {
            outofStock = true;
            if (res.data.reason === 'MANUAL') {
              history.push(`/machineUI/out-of-order/${machineID}`);
            } else {
              history.push(`/machineUI/out-of-order/${machineID}`);
            }
          } else {
            outofStock = false;
          }
        });
      }

      if (props.test == 'false') {
        await localRequest({
          method: 'get',
          url: '/getInventory',
        }).then((res) => {
          if (res.data.items) {
            items = res.data.items;
            // if (res.data.items_error && res.data.items_error.length > 0) {
            //   errorItems = res.data.items_error;
            //   console.log(errorItems);
            // }
          }
        });
      }
    };

    async function getCates() {
      if (isLocal) {
        await localRequest({
          method: 'get',
          url: getAllCateURL,
        })
          .then((res) => {
            categoryArray = res.data;
            console.log('localCate', res.data);
            localStorage.setItem('category', JSON.stringify(res.data));
          })
          .catch((err) => {
            console.log(err);
            logger(0, 'Errors when downloading categorys' + JSON.stringify(err));
          });
      } else {
        await request({
          method: 'get',
          url: getAllCateURLR + machineID,
        })
          .then((res) => {
            categoryArray = res.data[0];
            localStorage.setItem('category', JSON.stringify(res.data[0]));
          })
          .catch((err) => {
            console.log(err);
            logger(0, 'Errors when downloading categorys' + JSON.stringify(err));
          });
      }
    }

    async function getBrands() {
      if (isLocal) {
        await localRequest({
          method: 'get',
          url: getAllBrandURL,
        })
          .then((res) => {
            console.log('localBrand', res.data);
            localStorage.setItem('brand', JSON.stringify(res.data));
          })
          .catch((err) => {
            console.log(err);
            logger(0, 'Errors when downloading brands' + JSON.stringify(err));
          });
      } else {
        await request({
          method: 'get',
          url: getAllBrandURLR + machineID,
        })
          .then((res) => {
            localStorage.setItem('brand', JSON.stringify(res.data[0]));
          })
          .catch((err) => {
            console.log(err);
            logger(0, 'Errors when downloading brands' + JSON.stringify(err));
          });
      }
    }

    async function getProds() {
      if (isLocal) {
        await localRequest({
          method: 'get',
          url: getAllProdURL,
        })
          .then(async (res) => {
            console.log('localProduct', res.data);
            voidProd(res);
          })
          .catch((err) => {
            console.log(err);
            logger(0, 'Errors when downloading products' + JSON.stringify(err));
          });
      } else {
        await request({
          method: 'get',
          url: getAllProdURLR + machineID,
        })
          .then(async (res) => {
            console.log('remoteProduct', res.data);
            voidProd(res);
          })
          .catch((err) => {
            console.log(err);
            logger(0, 'Errors when downloading products' + JSON.stringify(err));
          });
      }
    }

    if (props.test == 'true') {
      localStorage.setItem('testMode', 'true');
      props.setTestMode(true);
    } else {
      localStorage.setItem('testMode', 'false');
      await updateStatus();
      props.setTestMode(false);
    }

    let run = async function () {
      await getPromo();
      await getMachine();
      await getProds();
      await getCates();
      await getBrands();
      logger(2, 'NextPage');
    };
    const nextPage = () => {
      try {
        if (audio.start) {
          stopPlay();
          // audio.checkout.play();
          audio.start?.play();
          // audio.cart.play();
        }

        stat.time = new Date();
        setStat(stat);
        //go to screensaver linked page directly instead of home page
        console.log('linkedpromo', props.linkPromo);
        console.log('filteredProducts', filteredProducts);
        console.log('categoryArray', categoryArray);

        if (
          myMachineObj?.themeColor?.c_column === '0' &&
          myMachineObj?.themeColor?.b_column === '0' &&
          localStorage.getItem('ENABLE_LOCKER') !== 'TRUE'
        ) {
          console.log('setHomesetHomesetHomesetHomesetHomesetHomesetHomesetHomesetHome');
          localStorage.setItem('homepage', `/machineUI/category/cate/all/all`);
        } else {
          localStorage.setItem('homepage', `/machineUI/homePage/${machineID}`);
        }

        if (isHelloFresh) {
          console.log('werwerwer1231e');
          return history.push(`/machineUI/helloFresh/${machineID}`);
        }

        let found = false;
        if (props.linkPromo) {
          if (props.linkPromo?.id !== '') {
            if (props.linkPromo?.p === 'prod') {
              filteredProducts.forEach((e) => {
                if (e._id === props.linkPromo.id) {
                  found = true;
                  console.log('gogo');
                  logger(
                    2,
                    'Leave Initial Page to' + `/machineUI/product/${machineID}/${e._id}/${e.idx}`
                  );
                  history.push(`/machineUI/product/${machineID}/${e._id}/${e.idx}`);
                }
              });
            }
            if (props.linkPromo?.p === 'cate') {
              categoryArray.forEach((e) => {
                if (e._id === props.linkPromo.id) {
                  if (!e.name[language] || !e.name[language] === '') {
                    e.name[language] = e.name.en;
                  }
                  localStorage.setItem('currentCate', JSON.stringify(e));
                  found = true;
                  logger(
                    'Leave Inital Page to' + `/machineUI/category/cate/${e.name[language]}/${e._id}`
                  );
                  history.push(`/machineUI/category/cate/${e.name[language]}/${e._id}`);
                }
              });
            }
          }
        }

        if (!found) {
          // history.push(`/machineUI/homePage/${machineID}`);
          console.log('2222');
          const homepage = localStorage.getItem('homepage');
          logger(2, 'Leave Initial Page to' + homepage);
          history.push(homepage);
        }
      } catch (err) {
        console.log('someerror', err);
        setInfo(JSON.stringify(err));
      }
    };

    if (!outofStock) {
      run().then((e) => {
        if (myMachineObj) {
          //run check if PING is enabled
          nextPage();
        } else {
          setInfo(`No Data found`);
        }
      });
    }
  }, []);

  return (
    <div className="main-container flex-column d-flex justify-content-center align-items-center">
      <div className="init-div">{initText}</div>
      <div className="init-div">{info}</div>
    </div>
  );
}
export default Initial;
